import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export const SkipLoading = new HttpContextToken<boolean>(() => true);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

intercept(
	req: HttpRequest<any>,
	next: HttpHandler
): Observable<HttpEvent<any>> {
	if (req.context.get(SkipLoading)) {
		return next.handle(req);
	}

	this.loadingService.setIsSpinning(true);

	return next.handle(req).pipe(
		finalize(() => {
			this.loadingService.setIsSpinning(false);
		})
	);
}
}
